import { ReactNode } from 'react';

import testBooster from '@backrs_ui/grow-ui/src/assets/images/sessionBanners/test_booster.png';

import { Box, SxProps, Theme } from '@mui/material';

type TestBoosterBannerProps = Readonly<{
  actions?: ReactNode;
}>;

/** Test Booster header image. Standalone (no shell session), so it doesn't route through SessionBanner. */
export const TestBoosterBanner = ({ actions }: TestBoosterBannerProps) => (
  <Box sx={containerSx}>
    <Box sx={cardSx}>
      <Box component="img" src={testBooster} alt="" sx={imageSx} />
      {actions ? <Box sx={actionsSx}>{actions}</Box> : null}
    </Box>
  </Box>
);

const containerSx: SxProps<Theme> = {
  flexShrink: 0,
};

const cardSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  borderRadius: backrs.radius['radius-xl'],
  border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  backgroundColor: backrs.colors['Brand/50'],
});

const actionsSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'absolute',
  top: backrs.spacing['spacing-lg'],
  right: backrs.spacing['spacing-lg'],
});

const imageSx: SxProps<Theme> = {
  display: 'block',
  width: '100%',
  maxHeight: 180,
  height: 'auto',
  objectFit: 'contain',
  objectPosition: 'center',
};
